var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "jp-upload",
      class: { "jp-upload-round": _vm.round },
      style: _vm.style,
    },
    [
      _vm.file && _vm.file.status != "success"
        ? _c(
            "div",
            { staticClass: "jp-upload__uploading" },
            [
              _c(
                "div",
                { staticClass: "jp-upload__progress" },
                [
                  _c("el-progress", {
                    attrs: {
                      percentage: _vm.file.percentage,
                      "text-inside": true,
                      "stroke-width": 16,
                    },
                  }),
                ],
                1
              ),
              _c("el-image", {
                staticClass: "image",
                attrs: { src: _vm.file.tempFile, fit: "cover" },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.file && _vm.file.status == "success"
        ? _c(
            "div",
            { staticClass: "jp-upload__img" },
            [
              _c("el-image", {
                staticClass: "image",
                attrs: {
                  src: _vm.file.url,
                  "preview-src-list": [_vm.file.url],
                  fit: "cover",
                  "hide-on-click-modal": "",
                  "append-to-body": "",
                  "z-index": 9999,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "placeholder",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "jp-upload__img-slot" }, [
                            _vm._v("Loading..."),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  3623084002
                ),
              }),
              !_vm.disabled
                ? _c("div", { staticClass: "jp-upload__img-actions" }, [
                    _c(
                      "span",
                      {
                        staticClass: "del",
                        on: {
                          click: function ($event) {
                            return _vm.handleRemove()
                          },
                        },
                      },
                      [_c("i", { staticClass: "el-icon-delete" })]
                    ),
                  ])
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      !_vm.file
        ? _c(
            "el-upload",
            {
              ref: "uploader",
              staticClass: "uploader",
              attrs: {
                "auto-upload": _vm.cropper ? false : _vm.autoUpload,
                disabled: _vm.disabled,
                "show-file-list": _vm.showFileList,
                action: _vm.action,
                name: _vm.name,
                data: _vm.data,
                accept: _vm.accept,
                limit: 1,
                "http-request": _vm.request,
                "on-change": _vm.change,
                "before-upload": _vm.before,
                "on-success": _vm.success,
                "on-error": _vm.error,
                "on-exceed": _vm.handleExceed,
              },
            },
            [
              _vm._t("default", function () {
                return [
                  _c("div", { staticClass: "el-upload--picture-card" }, [
                    _c("div", { staticClass: "file-empty" }, [
                      _vm.title
                        ? _c("h4", [
                            _c("i", { class: _vm.icon }),
                            _vm._v(" " + _vm._s(_vm.title) + " "),
                          ])
                        : _c("i", { class: _vm.icon }),
                    ]),
                  ]),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
      _c(
        "span",
        { staticStyle: { display: "none !important" } },
        [
          _c("el-input", {
            model: {
              value: _vm.value,
              callback: function ($$v) {
                _vm.value = $$v
              },
              expression: "value",
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "剪裁",
            draggable: "",
            width: "580",
            "destroy-on-close": "",
          },
          on: { closed: _vm.cropperClosed },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.cropperDialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.cropperSave },
                    },
                    [_vm._v("确 定")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.cropperDialogVisible,
            callback: function ($$v) {
              _vm.cropperDialogVisible = $$v
            },
            expression: "cropperDialogVisible",
          },
        },
        [
          _c("cropper", {
            ref: "cropper",
            attrs: {
              src: _vm.cropperFile.tempCropperFile,
              compress: _vm.compress,
              aspectRatio: _vm.aspectRatio,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }